import { render, staticRenderFns } from "./Form3_Persona.vue?vue&type=template&id=15622595"
import script from "./Form3_Persona.vue?vue&type=script&lang=js"
export * from "./Form3_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15622595')) {
      api.createRecord('15622595', component.options)
    } else {
      api.reload('15622595', component.options)
    }
    module.hot.accept("./Form3_Persona.vue?vue&type=template&id=15622595", function () {
      api.rerender('15622595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/HIPOTECALO/Form3_Persona.vue"
export default component.exports